module.exports = __webpack_public_path__ + "static/media/design-img-4.6a60ecb1.jpg";